import { LevelPlayActivity } from '@/shared/level-play'

import { getConfigByKind } from '../../Challenges/config'
import { useLevelContext } from '../../context'
import { DigitalProductJourneyLevelPlayChallengeFooter } from './Footer'
import { DigitalProductJourneyLevelPlayChallengeToolbar } from './Toolbar'

/**
 * Wrapper de domínio sobre o shell compartilhado.
 *
 * Injeta o que é da jornada — o registro de kinds, o lookup do desafio e os
 * componentes de Footer e Toolbar — e nada mais. A orquestração do step vive em
 * `LevelPlayActivity`.
 */
export const DigitalProductJourneyLevelPlayChallenge = () => {
  const {
    steps,
    currentStepIndex,
    methods,
    getChallenge,
    onChallengeVerifyAnswer
  } = useLevelContext()

  return (
    <LevelPlayActivity
      steps={steps}
      currentStepIndex={currentStepIndex}
      methods={methods}
      getActivity={getChallenge}
      getConfigByKind={getConfigByKind}
      onVerifyAnswer={onChallengeVerifyAnswer}
      Toolbar={DigitalProductJourneyLevelPlayChallengeToolbar}
      Footer={DigitalProductJourneyLevelPlayChallengeFooter}
    />
  )
}
